<panel name="PROPERTY_TYPE" *ngIf="rows.get(0)">
  <form-preview-element
    [isReadonly]="isReadonly"
    [row]="rows.get(0)"
    [values]="values"
    [activeForm]="activeForm"
    (onSelect)="handleSelectChange($event, rows.getIn([0, 'name']))"
    (onSelectInput)="handleSelectInput($event, rows.getIn([0, 'name']))"
    (onInput)="handleFieldChange($event)"
  ></form-preview-element>
</panel>

<panel class="is-block mt-5" name="FEATURES">
  <div class="features">
    <div class="features-head">
      <div>
        {{ 'FEATURE' | translate }}
      </div>
      <div>
        {{ 'VALUE' | translate }}
      </div>
      <div></div>
    </div>
    <form-preview-element
      [isReadonly]="isReadonly"
      [row]="row"
      *ngFor="let row of rows.delete(0)"
      [values]="values"
      [activeForm]="activeForm"
      (onSelect)="handleSelectChange($event, row.get('name'))"
      (onSelectInput)="handleSelectInput($event, row.get('name'))"
      (onInput)="handleFieldChange($event)"
    ></form-preview-element>
  </div>
</panel>
